
import { defineComponent, ref } from "vue";
import Game from "@/components/game/Game.vue";

export default defineComponent({
  name: "GameView",
  props: {
    ai: {
      type: Boolean,
    },
    deckId: {
      type: Number,
    },
    static: {
      type: Boolean,
    },
  },
  components: {
    Game,
  },

  setup() {
    const notFound = ref(false);
    return { notFound };
  },
});
